/**
 * @file
 * Click-to-play video posters: swap the poster for the player in place.
 */
(function (Drupal, once) {
  "use strict";

  Drupal.behaviors.umsiVideoPoster = {
    attach: function (context) {
      once("umsi-video-poster", ".video-poster__button", context).forEach(
        function (button) {
          button.addEventListener("click", function (e) {
            var url = button.dataset.videoUrl;
            var wrapper = button.closest(".video-poster");
            // Only ever frame an https embed.
            if (!url || url.indexOf("https://") !== 0 || !wrapper) {
              return;
            }
            e.preventDefault();

            var iframe = document.createElement("iframe");
            iframe.className = "video-poster__player";
            iframe.src = url;
            iframe.title = button.dataset.videoTitle || "Video player";
            iframe.setAttribute(
              "allow",
              "autoplay; encrypted-media; picture-in-picture; fullscreen",
            );
            iframe.setAttribute("allowfullscreen", "");
            iframe.setAttribute("frameborder", "0");

            wrapper.replaceChildren(iframe);
            // The activated control is gone, so focus would fall to the document.
            iframe.focus();
          });
        },
      );
    },
  };
})(Drupal, once);
